import { createEditV2 } from "src/framework/editV2/createEditV2.tsx";
import { createCreateV2 } from "src/framework/createV2/createCreateV2.tsx";

export const createFormRoute = ({
  type,
  resource,
  layoutForm,
  tab,
}: {
  resource: string;
  type: "create" | "edit";
  layoutForm?: boolean;
  tab?: string;
}) => {
  return type === "edit"
    ? createEditV2({
        resource,
        layoutForm,
        tab,
      })
    : createCreateV2({
        resource,
        layoutForm,
        tab,
      });
};
